// extracted by mini-css-extract-plugin
export var brandingLabel = "JX3ux";
export var devSourceLabel = "wvicW";
export var headerCenter = "nfT_v";
export var headerCharmsAndSearch = "anQE3";
export var headerFullBleed = "zTtkm";
export var headerLeft = "I7Ynq";
export var headerLeftCharms = "L7fUK";
export var headerMain = "hl2hm";
export var headerRight = "PK3EO";
export var headerSearchBox = "Rn_96";
export var headerSearchScopePicker = "bDsVn";